const initialState = {
  loading: false,
  user: null,
  error: null
}

function reducer (state = initialState, action) {
  switch (action.type) {
    case 'SET_USER': {
      return {
        ...initialState,
        user: action.user
      }
    }
    case 'SET_USER_LOADING': {
      return {
        ...initialState,
        loading: true
      }
    }
    case 'SET_USER_ERROR': {
      return {
        initialState,
        error: action.error
      }
    }
    default: return state
  }
}

export default reducer
